import { render } from "./CardOrcamento.vue?vue&type=template&id=5d181d32&scoped=true"
import script from "./CardOrcamento.vue?vue&type=script&lang=ts"
export * from "./CardOrcamento.vue?vue&type=script&lang=ts"

import "./CardOrcamento.vue?vue&type=style&index=0&id=5d181d32&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5d181d32"

export default script